var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_6653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4514 7.33647C18.4513 7.17078 18.3855 7.0119 18.2683 6.89474C18.1512 6.77758 17.9923 6.71173 17.8266 6.71168L11.1229 6.71002C10.9572 6.71007 10.7983 6.77592 10.6811 6.89308C10.564 7.01024 10.4981 7.16913 10.4981 7.33482L10.5069 13.6745C10.5069 13.6745 8.20772 14.4412 7.89173 17.4C7.88204 17.4875 7.89091 17.5759 7.91777 17.6597C7.94462 17.7435 7.98885 17.8206 8.04756 17.8861C8.10627 17.9516 8.17814 18.0039 8.25848 18.0397C8.33882 18.0756 8.42581 18.094 8.51376 18.0939L20.4346 18.0933C20.5235 18.093 20.6114 18.0737 20.6923 18.0367C20.7732 17.9997 20.8453 17.9458 20.9037 17.8787C20.9621 17.8116 21.0055 17.7328 21.031 17.6476C21.0565 17.5624 21.0636 17.4727 21.0516 17.3846C20.8986 16.3046 20.36 14.3098 18.4613 13.6772L18.4514 7.33647Z",
    stroke: "#808187",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4739 18.094L14.4739 23.4294",
    stroke: "#808187",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_6653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.331772 14.5908) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownpin);
export default __webpack_public_path__ + "static/media/downpin.02b4b977af179a356598ef783c75e23b.svg";
export { ForwardRef as ReactComponent };